import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';

/** Shown when /me says the user has neither `connect` nor `admin` on the vpn resource. */
export function NoAccess() {
  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        <MessageBarTitle>You do not have access to the VPN</MessageBarTitle>
        Your account is signed in but has not been granted the <strong>connect</strong> permission on the
        VPN resource. Ask an administrator to grant it in VIPPER IAM, then reload this page.
      </MessageBarBody>
    </MessageBar>
  );
}
